module.exports = __webpack_public_path__ + "assets/instagram.335f62de.svg";